<template>
  <div :class="[ hidden && 'd-none']">
    <div
      class="my-4 border-bottom"
      style=" border-color: #D2D6DC !important"
    >
      <h2>{{ label }}</h2>
    </div>
  </div>
</template>

<script>
import FormMixin from './FormMixin'

export default {
  name: 'FormHeading',
  mixins: [ FormMixin ],
}
</script>
